import { ActionUserInfo } from '@/app/models/projects-service'
import { formatDate, formatDateLocale } from '@/app/utils/commonFunctions'
import { BareHtml } from '../Messaging/Message/BareHtml'
import './RedoReasons.scss'

const RedoReasons = (props: { actionUserInfo: ActionUserInfo }) => {
    const { actionUserInfo } = props

    const componentClass = 'smart-modals-news-execution-redo-reasons'
    const message =
        typeof actionUserInfo.message === 'string'
            ? actionUserInfo.message
            : `${actionUserInfo.message.jobs ?? ''}
            ${actionUserInfo.message.questions ?? ''}
            ${actionUserInfo.message.surveys ?? ''}
            ${actionUserInfo.message.photos ?? ''}`

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__message`}>
                {<BareHtml.div innerHTML={{ __html: message }} />}
            </div>
            <div className={`${componentClass}__details`}>
                <div className={`${componentClass}__details__date`}>
                    {formatDateLocale(formatDate(actionUserInfo.date))}
                </div>
                <div className={`${componentClass}__details__user`}>
                    {`${actionUserInfo.role} - ${actionUserInfo.nickname ? actionUserInfo.nickname : 
                        actionUserInfo.name}${actionUserInfo.nickname ? '' : ' ' + actionUserInfo.lastname}`}
                </div>
            </div>
        </div>
    )
}

export default RedoReasons
